const SectionTransition = ({ index, label, bridgeId }) => (
  <div
    className="cinematic-section-bridge"
    data-section-bridge={bridgeId}
    aria-hidden="true"
  >
    <span className="cinematic-section-bridge-index">{String(index).padStart(2, '0')}</span>
    <span className="cinematic-section-bridge-line" />
    <span className="cinematic-section-bridge-label">{label}</span>
  </div>
)

export default SectionTransition
